import { render, staticRenderFns } from "./IconAcademy.vue?vue&type=template&id=7cc0b13c"
import script from "./IconAcademy.vue?vue&type=script&lang=js"
export * from "./IconAcademy.vue?vue&type=script&lang=js"
import style0 from "./IconAcademy.vue?vue&type=style&index=0&id=7cc0b13c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports